export enum PerfectChipVariants {
  Fill = 'FILL',
  Outline = 'OUTLINE',
}
